angular.module("avvisoRiscatto.components", [])
    .component("avvisoRiscatto", {
        templateUrl: "ng/components/riscattoTermine/avvisoRiscatto/avvisoRiscatto.view.html",
        bindings: {
            richiestePostVendita: "<",
            numContratto: "<",
            numModulo: "<",
            postVendita: "<",
            validateComponent: "&"
        },
        controllerAs: "avvisoRiscattoCtrl",
        controller: function AvvisoRiscatto(
            $arcService,
            $download,
            validationService,
            $rootScope,
            $typeDomainService,
            $timeout,
            Riferimenti
        ) {
            var self = this;

            var initProvince = function () {
                self.supportModel.provinceType = $rootScope.comuniMap
                    .map(function (comune) {
                        return comune.sigla;
                    })
                    .filter(function (siglaComune) {
                        return siglaComune != "";
                    })
                    .sort()
                    .reduce(function (result, nextItem) {
                        return result.includes(nextItem) ? result : result.concat(nextItem);
                    }, []);
            };

            self.appContract = {
                numeroContratto: null,
                modulo: null,
                cdBeni: []
            }

            self.contratti = [];

            self.$onInit = function () {

                self.supportModel = {
                    restIsPending: false,
                    riscattoAccettato: true,
                    showWarming: false,
                    preventivePrinted: false,
                    restDownloadRunning: false,
                    listOfDocumentDownload: [],
                    initialIndex: 0,
                    testCf: false,
                    agenzieNautiche: [],
                    opzioniAgenzia: undefined,
                    agenziaSelected: false,
                    textRiscSi: "",
                    textRiscNo: ""
                }
                if (self.richiestePostVendita.metadata.riscattoATermine.accepted == null) {
                    self.richiestePostVendita.metadata.riscattoATermine.accepted = true;
                } else {
                    self.supportModel.riscattoAccettato = self.richiestePostVendita.metadata.riscattoATermine.accepted
                }

                self.showContattiNotaio = self.richiestePostVendita.ctrRichiestaList[0].codProdotto == 'FLY' ? true : false;
                self.showAgenziaNautica = self.richiestePostVendita.ctrRichiestaList[0].codProdotto == 'NAV' ? true : false;
                initProvince();
                //self.getDocs();
                getAgenzieNav();
                self.checkValidityComponent();
                if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato) {

                    getMessageIpt(self.richiestePostVendita.metadata.riscattoATermine.provinciaImmatricolazione);
                } else {

                    $timeout(function () {
                        self.supportModel.textRiscSi = self.richiestePostVendita.metadata.riscattoATermine.textRiscSi &&
                            self.richiestePostVendita.metadata.riscattoATermine.textRiscSi
                                .replace(/#u#/gi, '<u>')
                                .replace(/#\/u#/gi, '</u>')
                        self.supportModel.textRiscNo = self.richiestePostVendita.metadata.riscattoATermine.textRiscNo &&
                            self.richiestePostVendita.metadata.riscattoATermine.textRiscNo
                                .replace(/#u#/gi, '<u>')
                                .replace(/#\/u#/gi, '</u>')
                        jQuery('#riscattoSi').append(self.supportModel.textRiscSi);
                        jQuery('#riscattoNo').append(self.supportModel.textRiscNo);
                    }, 20)
                }
            }

            self.handleChange = function (property, value) {
                switch (property) {
                    case "acceptance":
                        if (value) {
                            self.supportModel.showWarming = false;
                            self.richiestePostVendita.metadata.riscattoATermine.accepted = true;
                            self.showContattiNotaio = self.richiestePostVendita.ctrRichiestaList[0].codProdotto == 'FLY' ? true : false
                            $timeout(function () {
                                jQuery('#riscattoSi').append(self.supportModel.textRiscSi);
                            }, 1)
                        } else {
                            self.supportModel.showWarming = true;
                            self.richiestePostVendita.metadata.riscattoATermine.accepted = false;
                            self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo = false;
                            self.richiestePostVendita.metadata.riscattoATermine.contattiSopralluogo = Riferimenti.build();
                            self.showContattiNotaio = false;
                            $timeout(function () {
                                jQuery('#riscattoNo').append(self.supportModel.textRiscNo);
                            }, 1)

                        }
                        break;
                    case "agenzieNautiche":
                        self.richiestePostVendita.metadata.riscattoATermine.agenziaNautica = value;
                        self.supportModel.agenziaSelected = true;
                        if (value.value == "AGITA") {
                            self.richiestePostVendita.metadata.riscattoATermine.opzioniAgenzia = null;
                            self.richiestePostVendita.metadata.riscattoATermine.agenziaPraticheNav = {};
                        }
                        break;
                    case "adempimentiNav":
                        self.richiestePostVendita.metadata.riscattoATermine.opzioniAgenzia = value;
                        break;
                    case "noteOperativeCliente":
                        self.richiestePostVendita.metadata.riscattoATermine.noteOperativeCliente = value;
                        break;
                    case "emailCliente":
                        self.richiestePostVendita.metadata.riscattoATermine.contatti.email = value;
                        break;
                    case "telefonoCliente":
                        self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono = value;
                        break;
                    case "descrizioneCliente":
                        self.richiestePostVendita.metadata.riscattoATermine.contatti.description = value;
                        break;
                    case "provinciaImmatricolazione":
                        getMessageIpt(value);
                        break;
                    case "riscattoTerzo":
                        if (!value) {
                            self.richiestePostVendita.metadata.riscattoATermine.riscattantePef = false;
                            self.richiestePostVendita.metadata.riscattoATermine.pivaTerzo = null;
                            self.richiestePostVendita.metadata.riscattoATermine.cfTerzo = null;
                            self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio = false;
                            self.richiestePostVendita.metadata.riscattoATermine.nomeRiscattante = null;
                            self.richiestePostVendita.metadata.riscattoATermine.cognomeRiscattante = null;
                            self.richiestePostVendita.metadata.riscattoATermine.cfTerzo = null;
                            self.richiestePostVendita.metadata.riscattoATermine.provinciaImmatricolazione = null;
                        }
                        getMessageIpt();
                        break;

                    case "concessionario":
                        self.richiestePostVendita.metadata.riscattoATermine.provinciaImmatricolazione = "";
                        if (value) {
                            self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio = false;
                        }
                        getMessageIpt();
                        break;

                    case "riscattantePef":
                        if (value) {
                            self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio = false;
                        }
                        break;
                }
                self.checkValidityComponent();
            }

            self.getDocs = function () {
                self.supportModel.restDownloadRunning = true;
                $arcService.downloadDocumentationRichiestaPostVendita(self.richiestePostVendita)
                    .then(function (response) {
                        self.supportModel.listOfDocumentDownload = response.listDocuments;
                        self.supportModel.restDownloadRunning = false;
                    })
                    .catch(function (error) {
                        console.error(error);
                        self.supportModel.restDownloadRunning = false;
                    })
            }

            var getAgenzieNav = function () {
                self.navalRestRunning = true;
                $typeDomainService
                    .getDomainSet("RISC_TER", "AGENZIE_NAUTICHE")
                    .then(function (response) {
                        self.supportModel.agenzieNautiche = response.domainList;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                $typeDomainService
                    .getDomainSet("RISC_TER", "ADEMPIMENTI_AGENZIA")
                    .then(function (response) {
                        self.supportModel.opzioniAgenzia = response.domainList;
                        self.navalRestRunning = false;
                    })
                    .catch(function (error) {
                        self.navalRestRunning = false;
                        console.log(error);
                    });
            }

            self.printPreventive = function () {
                if (self.richiestePostVendita.metadata.riscattoATermine.downloadKey) {
                    self.generdownloadDoc(self.supportModel.listOfDocumentDownload[0])
                    self.supportModel.preventivePrinted = true;
                } else {
                    console.log("Il rest di stampa non ha documenti da stampare. Per evitare errori in console ho piazzato questo messaggio");
                    self.supportModel.preventivePrinted = true;
                }
                self.checkValidityComponent();
            }

            self.generdownloadDoc = function (file) {
                var input = {
                    downloadKey: self.richiestePostVendita.metadata.riscattoATermine.downloadKey
                }
                var url = "/uni/downloadDoc8A1/service-infos/";
                $download.getGenericDownload(url, input)
                    .then(function (response) {
                        console.log(response);
                    })
            };

            self.checkValidityComponent = function () {

                var test = true;

                //valido il cf se il riscattante terzo è una PF
                if (self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo &&
                    self.richiestePostVendita.metadata.riscattoATermine.riscattantePef &&
                    self.richiestePostVendita.metadata.riscattoATermine.nomeRiscattante &&
                    self.richiestePostVendita.metadata.riscattoATermine.cognomeRiscattante) {

                    self.supportModel.testCf = validationService.checkCfWithName(self.richiestePostVendita.metadata.riscattoATermine.cfTerzo, self.richiestePostVendita.metadata.riscattoATermine.cognomeRiscattante, self.richiestePostVendita.metadata.riscattoATermine.nomeRiscattante);

                } else if (!self.richiestePostVendita.metadata.riscattoATermine.riscattantePef) {
                    self.supportModel.testCf = true;
                }

                //valido la sezione contatti
                var testCotatti = false;

                if (self.richiestePostVendita.metadata.riscattoATermine.canHideContact && !self.richiestePostVendita.metadata.riscattoATermine.prodottoImm && !self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo) {
                    testCotatti = true;

                } else {
                    if (self.richiestePostVendita.metadata.riscattoATermine.prodottoImm) {
                        if (self.supportModel.riscattoAccettato) {
                            testCotatti = !!self.richiestePostVendita.metadata.riscattoATermine.contatti.email &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contatti.description &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contattiSopralluogo.email &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contattiSopralluogo.telefono &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contattiSopralluogo.description

                        } else {
                            testCotatti = !!self.richiestePostVendita.metadata.riscattoATermine.contatti.email &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono &&
                                !!self.richiestePostVendita.metadata.riscattoATermine.contatti.description

                        }

                    } else if (self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo) {
                        testCotatti = !!self.richiestePostVendita.metadata.riscattoATermine.contatti.email &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.description &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiRiscattante.email &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiRiscattante.telefono &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiRiscattante.description
                    } else if (self.richiestePostVendita.metadata.riscattoATermine.prodottoNav && self.showContattiNotaio) {
                        testCotatti = !!self.richiestePostVendita.metadata.riscattoATermine.contatti.email &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.description &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiNotaio.email &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiNotaio.telefono &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contattiNotaio.description

                    } else {
                        testCotatti = !!self.richiestePostVendita.metadata.riscattoATermine.contatti.email &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.telefono &&
                            !!self.richiestePostVendita.metadata.riscattoATermine.contatti.description
                    }
                }


                //valido la sezione di avviso riscatgto a termine in base al tipo di prodotto
                if (self.richiestePostVendita.metadata.riscattoATermine.prodottoTargato) {
                    if (self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo && !self.richiestePostVendita.metadata.riscattoATermine.riscattantePef && self.richiestePostVendita.metadata.riscattoATermine.concessionario) {
                        test =
                            self.richiestePostVendita.metadata.riscattoATermine.pivaTerzo &&
                            self.richiestePostVendita.metadata.riscattoATermine.cfTerzo

                    } else if (self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo && !self.richiestePostVendita.metadata.riscattoATermine.riscattantePef && !self.richiestePostVendita.metadata.riscattoATermine.concessionario) {
                        test =
                            self.richiestePostVendita.metadata.riscattoATermine.pivaTerzo &&
                            self.richiestePostVendita.metadata.riscattoATermine.cfTerzo &&
                            self.richiestePostVendita.metadata.riscattoATermine.provinciaImmatricolazione;

                    } else if (self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo && !self.richiestePostVendita.metadata.riscattoATermine.riscattantePef) {
                        test =
                            self.richiestePostVendita.metadata.riscattoATermine.provinciaImmatricolazione &&
                            self.supportModel.testCf;
                    }

                } else if (self.richiestePostVendita.metadata.riscattoATermine.prodottoImm) {
                    test =
                        self.richiestePostVendita.metadata.riscattoATermine.condominio != undefined &&
                        self.richiestePostVendita.metadata.riscattoATermine.sublocatoTerzi != undefined;

                } else if (self.richiestePostVendita.metadata.riscattoATermine.prodottoNav) {
                    if (self.showAgenziaNautica && self.supportModel.riscattoAccettato) {
                        test =
                            (self.supportModel.agenziaSelected && self.richiestePostVendita.metadata.riscattoATermine.agenziaNautica.value === "AGITA") ||
                            (self.supportModel.agenziaSelected && self.richiestePostVendita.metadata.riscattoATermine.opzioniAgenzia &&
                                self.richiestePostVendita.metadata.riscattoATermine.agenziaPraticheNav && self.richiestePostVendita.metadata.riscattoATermine.agenziaPraticheNav.name && self.richiestePostVendita.metadata.riscattoATermine.agenziaPraticheNav.email);

                    } else {
                        test = true;
                    }
                }

                if (testCotatti && test) {
                    self.validateComponent({
                        validity: true
                    });
                } else {
                    self.validateComponent({
                        validity: false
                    });
                }

            }

            self.onCheckboxChangeNoleggio = function () {
                self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio = !self.richiestePostVendita.metadata.riscattoATermine.usoNoleggio;
            }

            var getMessageIpt = function (provincia) {
                self.isPendingMessageIpt = true;
                $arcService.getIpt(self.richiestePostVendita.id, provincia, self.richiestePostVendita.metadata.riscattoATermine.riscattoTerzo)
                    .then(function (response) {
                        if (response.success) {

                            self.supportModel.textRiscSi = response.message &&
                                response.message
                                    .replace(/#u#/gi, '<u>')
                                    .replace(/#\/u#/gi, '</u>');


                            $timeout(function () {
                                jQuery('#riscattoSi').append(self.supportModel.textRiscSi);
                            }, 1)

                        }
                        self.isPendingMessageIpt = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.isPendingMessageIpt = false;
                    })
            }

            self.handleChangeContattiSopralluogo = function (name, value) {
                self.richiestePostVendita.metadata.riscattoATermine.contattiSopralluogo[name] = value;
                self.checkValidityComponent();
            }

            self.handleChangeContattiRiscattante = function (name, value) {
                self.richiestePostVendita.metadata.riscattoATermine.contattiRiscattante[name] = value;
                self.checkValidityComponent();
            }

            self.handleChangeContattiNotaio = function (name, value) {
                self.richiestePostVendita.metadata.riscattoATermine.contattiNotaio[name] = value;
                self.checkValidityComponent();
            }
        }
    })